import React, {useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledTabs from 'components/atoms/Tabs/Tabs/Tabs.styles';
import utils from 'helpers/utils';

const Tabs = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    textColor: 'primary',
    indicatorColor: 'primary',
    ...props
  }, 'Tabs', {
    static: ['disabled'],
    variable: ['orientation']
  });

  const innerRef = useRef(null);

  useImperativeHandle(ref, () => innerRef.current);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledTabs ref={innerRef} {...innerProps}>
    {innerProps.children}
  </StyledTabs>
});

Tabs.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default Tabs;
